



































import Vue from "vue";
import mixins from "vue-typed-mixins";
import MenuItem from "./MenuItem.vue";
import PageListNavigator from "../mixins/PageListNavigator";
import { IPage } from "../store/state";

interface MiniMenuComputed {
  pages: IPage[];
}

export default mixins(PageListNavigator).extend<{}, {}, MiniMenuComputed, {}>({
  name: "MiniMenu",
  components: {
    MenuItem
  },
  computed: {
    pages() {
      return this.$store.state.pages;
    }
  }
});
